const DOESNT_MATTER = { label: "Doesn't matter", value: "" };

const withDoesntMatter = (options) => [DOESNT_MATTER, ...options];

export default withDoesntMatter;
